<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="services">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm10 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="brown darken-3">
                        <v-toolbar-title>Servicios&nbsp;&nbsp;</v-toolbar-title>
                        <v-text-field
                            :disabled="bEdit"
                            hide-details
                            single-line
                            v-model="searchText"
                        ></v-text-field>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn :disabled="bEdit" small icon @click="onSearch" v-on="on">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>Buscar</span>
                        </v-tooltip>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                :disabled="bEdit"
                                text
                                class="text-none"
                                @click="onNewService"
                            >Nuevo Servicio</v-btn>
                            <v-btn
                                :disabled="(bEdit || serviceID === 0 )"
                                text
                                class="text-none"
                                @click="onEditService"
                            >Editar Servicio</v-btn>
                            <v-btn
                                :disabled="(bEdit || serviceID === 0 )"
                                text
                                class="text-none"
                                @click="onDeleteService"
                            >Borrar Servicio</v-btn>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text :disabled="bEdit" @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item :disabled="bEdit" @click="onNewService">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-flag-plus</v-icon>&nbsp; Nuevo Servicio
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onEditService">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-pencil</v-icon>&nbsp; Editar Servicio
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onDeleteService">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-flag-remove</v-icon>&nbsp; Borrar Servicio
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item :disabled="bEdit" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de servicios y servicio seleccionado: -->
                    <v-container pa-2 grid-list-md>
                        <!-- Renglón único para lista de servicios y card de servicio seleccionado: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de servicios: *************************** -->
                            <v-flex xs10 sm3>
                                <v-card>
                                    <v-toolbar dense color="brown darken-1" dark flat>
                                        <v-toolbar-title class="my-list-title">Servicios registrados</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="listHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        :disabled="bEdit"
                                        color="grey lighten-4"
                                    >
                                        <v-list-item-group
                                            v-model="selectedServiceIndex"
                                            color="orange accent-4"
                                            :mandatory="!bNew"
                                        >   
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(service, i) in services"
                                                :key="i"
                                                @click="selectService(service.servicioid)"
                                                :id="service.servicioid"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex
                                                                    md2
                                                                    xs6
                                                                >{{ service.servicio }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina Lista de servicios ********************************* -->

                            <!-- Info de servicio seleccionado: *********************** -->
                            <v-flex xs10 sm9>
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="brown lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >{{ selectedServiceName }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-flag</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-flag"
                                                        name="servicio"
                                                        label="Servicio"
                                                        type="text"
                                                        v-model="serviceName"
                                                        :readonly="!bEdit"
                                                        color="green darken-3"
                                                        ref="name_field"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout
                                                v-if="bEdit"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSave"
                                                        :disabled="!bEdit"
                                                    >OK</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                        :disabled="!bEdit"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de servicio seleccionado *********************** -->
                        </v-layout>

                        <!-- Modal para confirmar borrado de servicio: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingService" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Servicio</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar al servicio "{{ selectedServiceName }}"?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteServiceConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteService"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de servicio *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Búsqueda de Servicios</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >No hay servicios registrados con ese nombre.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no hubo resultados en la búsqueda *************************** -->

                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Información incorrecta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert-circle</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->

                        

                        <!-- Termina renglón único para lista de servicios y servicio seleccionado -->
                    </v-container>
                    <!-- Termina container para lista de servicios y servicio seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'services',
    data() {
        return {
            drawer: false,
            bEdit: false,
            bNew: false,
            bInvalidData: false,
            errorMessage: '',

            serviceID: 0,
            serviceName: '',
            
            selectedServiceName: '',
            bDeletingService: false,

            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.

        };
    },
    created() {
        this.selectFirstService();
        //console.log('services: ', this.services);
    },
    
    methods: {
        onClose() {
            this.$router.push('/').catch(err => {});
        },

        onNewService() {
            this.bEdit = true;
            this.bNew = true;
            this.selectedServiceName = 'Nuevo Servicio';
            this.selectedServiceIndex = -1;

            this.serviceID = 0;
            this.active = true;
            this.serviceName = '';
            
             this.$refs.name_field.focus();
        },

        onDeleteService() {
            this.bDeletingService = true;
        },

        cancelDeleteService() {
            this.bDeletingService = false;
        },

        deleteServiceConfirmed() {
            this.bDeletingService = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            var i;
            for (i = 0; i < this.services.length; i++)
            {
                if (this.services[i].servicioid === this.serviceID)
                {
                    this.services.splice(i, 1);
                    break;
                }
            }

            this.$store.dispatch('deleteService', this.serviceID);
            this.selectFirstService();
        },

        onEditService() {    
            this.bEdit = true;
            this.$refs.name_field.focus();
        },
        
        onCancel() {
            if (this.bNew) {
                //Selecciona al primer servicio de la lista:
                this.selectFirstService();
                this.bNew = false;
            } else {
                
                //Vuelve a obtener los datos originales del servicio seleccionado:
                this.selectService(this.serviceID);
            }
            this.bEdit = false;
        },

        onSave()
        {
            this.bInvalidData = false;

            //Se validan los datos:

            if (this.serviceName === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'Teclee el nombre del servicio.';
            }
            else
            {
                //Checa si hay otro servicio con el mismo nombre:
                for (let i = 0; i < this.services.length; i ++)
                {
                    //Si se está editando el servicio, se salta el servicio en edición (si es un servicio nuevo, serviceID = 0 y nunca va a ser igual al de otro servicio):
                    if (this.services[i].servicioid === this.serviceID)
                    {
                        continue;
                    }
                    else
                    if (this.services[i].servicio === this.serviceName)
                    {
                        this.bInvalidData = true;
                        this.errorMessage = "Ya existe otro servicio con el mismo nombre."
                        break;
                    }
                }
            }
            if (!this.bNew && !this.bInvalidData)
            {
                //Edición de servicio...
                var i; 

                const serviceInfo = {
                    servicioid: this.serviceID,
                    servicio: this.serviceName,
                };

                //Edición del registro en la BD:
                this.$store.dispatch('editService', serviceInfo);

                //Se actualiza el registro local:
                for (i = 0; i < this.services.length; i++)
                {
                    if (this.services[i].servicioid === this.serviceID)
                    {
                        this.services[i].servicio = this.serviceName;
                        break;
                    }
                }
            } //end edición de servicio.
            else if (this.bNew && !this.bInvalidData)
            {
                //Registro de nuevo servicio...
                this.bNew = false;

                const newService = {
                    servicioid: 0,
                    servicio: this.serviceName
                };

                this.$store.dispatch('saveNewService', newService);
            } //end registro de nuevo servicio.

            if (!this.bInvalidData)
            {
                this.selectedServiceName = this.serviceName;
                this.bEdit = false;
            }
        },

        selectFirstService()
        {
            if (this.services.length > 0)
            {
                this.selectedServiceIndex = 0;
                var serviceID = this.services[this.selectedServiceIndex].servicioid;
                this.selectService(serviceID);
            }
            else
            {
                this.selectedServiceIndex = -1;
                this.serviceID = 0;
            }
        },

        selectService(serviceID)
        {
            var i;
            for (i = 0; i < this.services.length; i++)
            {
                if (this.services[i].servicioid === serviceID)
                {
                    this.serviceID = serviceID;
                    this.serviceName = this.services[i].servicio;
                    this.selectedServiceName = this.serviceName;

                    break;
                }
            }
        },

        onSearch()
        {
            if (this.searchText != '')
            {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var i;
                var bFound = false;
                for (i = 0; i < this.services.length; i++)
                {
                    var strLowerCaseText = this.services[i].servicio.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0)
                    {
                        this.selectedServiceIndex = i;
                        this.scroll(this.services[i].servicioid);
                        this.selectService(this.services[i].servicioid);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound)
                {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },

        scroll(id)
        {
            document.getElementById(id).scrollIntoView({behavior: "smooth"});
        }
    },
    computed:
    {
        ...mapGetters([
            'services',
            'waitCursor',
            'userTypes'
        ]),
        selectedServiceIndex:
        {
            get() {
                return this.$store.getters.selectedServiceIndex;
            },
            set(selectedServiceIndex) {
                this.$store.dispatch(
                    'updateSelectedServiceIndex',
                    selectedServiceIndex
                );
            },
        },

        // style="height: 578px; max-height:100%"
        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '700px';
            } else {
                height = '470px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        
    },
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.6);
}
.services {
    background: url('../assets/fondo.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>